module.exports = __webpack_public_path__ + "static/media/IBM Auditorium_00000.77c8efa7.jpg";